import axiosClient from './axiosClient';

export const requestBundleRedeemOtp = async () => {
  try {
    const response = await axiosClient.post('v1/bundle/redeem-otp');
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
};

export const completeBundleRedeem = async (data) => {
  try {
    const response = await axiosClient.post('v1/bundle/redeem-claim', data);
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
};

export const fetchBundleTasks = async (bundleCode) => {
  try {
    const response = await axiosClient.post('v1/bundle/tasks', { bundle_code: bundleCode });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'An error occurred' };
  }
};

export const submitBundleTaskEntry = async (challengeId, entryImage) => {
  const formData = new FormData();
  formData.append('entryImage', entryImage);
  formData.append('challengeId', challengeId);

  try {
    const response = await axiosClient.post('v1/bundle/tasks/entry', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'An error occurred' };
  }
};
